type SpotifyEmbedProps = {
  artistId: string;
  className?: string;
  tall?: boolean;
};

export function SpotifyEmbed({ artistId, className = "", tall = false }: SpotifyEmbedProps) {
  const embedUrl = `https://open.spotify.com/embed/artist/${artistId}?utm_source=generator&theme=0`;
  const height = tall ? 360 : 152;

  return (
    <div className={`festapp-spotify-embed ${className}`} style={{ height }}>
      <iframe
        src={embedUrl}
        width="100%"
        height={height}
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        sandbox="allow-scripts allow-same-origin allow-popups"
        loading="lazy"
        title="Spotify Player"
      />
    </div>
  );
}
